export const SHIELD_PATHS = {
  Shield: 'shield',
  ShieldDDoS: 'ddos',
  ShieldEventLogs: 'event-logs',
  ShieldOverview: 'overview',
  ShieldRateLimit: 'rate-limit',
  ShieldWaf: 'waf',
  ShieldWafGeneral: 'general',
  ShieldWafRules: 'rules',
  ShieldWafTriggeredRules: 'triggered-rules',
  ShieldSetup: 'setup',
  ShieldBotDetection: 'bot-detection',
  TrafficManager: 'traffic-manager',
  ShieldAccessLists: 'access-lists',
  ShieldAccessListsCustom: 'custom',
  ShieldAccessListsCuratedThreatLists: 'curated-threat-lists',
} as const;
